// extracted by mini-css-extract-plugin
export var button = "_ag-7";
export var buttonRow = "_ag-6";
export var fadeIn = "_ag-1";
export var gradient = "_ag-0";
export var panel = "_ag-2";
export var panelIn = "_ag-3";
export var subtitle = "_ag-5";
export var title = "_ag-4";